<template>
  <ProSpaceModal
    width="410"
    :disabledApply="false"
    :title="$t('agencyTerritoryParams')"
    icon='boxes'
    @apply="$emit('agencyTerritoryEdit', filter)"
    :cancelTxt="$t('cancelTxt')"
    :applyTxt="$t('applyTxt')"
    v-model="filter"
  >
    <ProSpaceVLayout :gap="20">
      <ProSpaceSearchfield
        v-model="filter.kasValue"
        :service="kasService"
        label="KAS"
        :placeholder-value="$t('kAS')"
        :cancelTxt="$t('closeTxt')"
        :applyTxt="$t('selectTxt2')"
        :clearFilterTxt="$t('clearTxt')"
        :txtTitleModal="$t('kAS')"
        :search-placeholder="$t('searchTxt')"
        get-method="grid"
        optionLabel="value"
        optionValue="value"
        :fastFilters="[]"
        :defaultFilter="searchfieldDefaultFilter"
        :gridStyles="searchfieldGridStyles"
        :columns="[
          { field: 'value', header: $t('kASValue') },
        ]"
      />
      <ProSpaceSearchfield
        v-model="filter.merchandiserValue"
        :service="merchandiserService"
        :label="$t('merchandiser')"
        :placeholder-value="$t('merchandiser')"
        :cancelTxt="$t('closeTxt')"
        :applyTxt="$t('selectTxt2')"
        :clearFilterTxt="$t('clearTxt')"
        :txtTitleModal="$t('merchandiser')"
        :search-placeholder="$t('searchTxt')"
        get-method="grid"
        optionLabel="value"
        optionValue="value"
        optionCode="code"
        :fastFilters="[]"
        :defaultFilter="searchfieldDefaultFilter"
        :gridStyles="searchfieldGridStyles"
        :columns="[
          { field: 'value', header: $t('kASValue') },
        ]"
      />
      <ProSpaceSearchfield
        v-model="filter.routeCodeValue"
        :service="routeCodeService"
        :label="$t('routeCode')"
        :placeholder-value="$t('routeCode')"
        :cancelTxt="$t('closeTxt')"
        :applyTxt="$t('selectTxt2')"
        :clearFilterTxt="$t('clearTxt')"
        :txtTitleModal="$t('routeCode')"
        :search-placeholder="$t('searchTxt')"
        get-method="grid"
        optionLabel="value"
        optionValue="value"
        optionCode="code"
        :fastFilters="[]"
        :defaultFilter="searchfieldDefaultFilter"
        :gridStyles="searchfieldGridStyles"
        :columns="[
          { field: 'value', header: $t('kASValue') },
        ]"
      />
    </ProSpaceVLayout>
  </ProSpaceModal>
</template>

<script>
import {
  ProSpaceModal,
  ProSpaceSearchfield,
  ProSpaceVLayout
} from "@prospace/prospace-components-library";
import { mapGetters } from "vuex";

export default {
  name: "AgencyTerritoryModal",
  components: {
    ProSpaceModal,
    ProSpaceSearchfield,
    ProSpaceVLayout
  },
  props: {
    kasService: {
      type: Object,
    },
    merchandiserService: {
      type: Object,
    },
    routeCodeService: {
      type: Object
    }
  },
  data() {
    return {
      filter: {
        kasValue: null,
        routeCodeValue: null,
        merchandiserValue: null
      },
      searchfieldDefaultFilter: { disabled: { and: [false] } },
      searchfieldGridStyles: { height: '500px', width: '30vw', minWidth: '400px' }
    };
  },
  methods: {
    filesCountHandler(evt) {
      this.filesCount = evt;
    },
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      currentPeriod: "marsPeriodStore/getMarsPeriod"
    }),
  }
};
</script>

<style lang="scss">

</style>
